// extracted by mini-css-extract-plugin
export default {"infoBlock":"components-Shared-InfoBlock-styles__infoBlock--OjrGU","description":"components-Shared-InfoBlock-styles__description--EYXKo"};